// extracted by mini-css-extract-plugin
module.exports = {"bg":"_3Dkhj0q07uYzoxtRGWX_2f","sidebar":"_2S99EUOikNTVuyh0VjxMW_","boxBtnClose":"_3QZBQhLopl5v9pLBwvxJLC","btnClose":"_1kbe_4ASadzU1w3UST2a-O"};